import { Interpolate, Message } from '@wg/wows-react-uikit';

import { t } from '~/helpers/localization';
import { isClanDescriptionOnPreModeration } from '~/helpers/moderation';

import styles from './ClanDescription.scss';

import type { PreModerationField } from '~/types/declaration';

interface ClanDescriptionPreModeraionProps {
  clan: {
    preModeration: PreModerationField[];
  };
}

const ClanDescriptionPreModeraion = ({ clan }: ClanDescriptionPreModeraionProps) => {
  let preModerationMessageTemplate = t(
    'Вы не можете изменить %(pre_moderation_property_name)s, пока профиль вашего клана находится на премодерации.',
  );
  let preModerationMessageProperty = t('описание клана:pre_moderation_property_name');
  if (isClanDescriptionOnPreModeration(clan)) {
    preModerationMessageTemplate = t(
      '%(pre_moderation_property_name)s вашего клана обновится, как только оно будет одобрено модератором.',
    );
    preModerationMessageProperty = t('Описание:pre_moderation_property_name');
  }

  return (
    <div className={styles.onPremoderationDisclaimer}>
      <Message style={'inline'} type="error">
        <Interpolate
          useDangerouslySetInnerHTML={true}
          str={preModerationMessageTemplate}
          parentTag={'p'}
          pre_moderation_property_name={preModerationMessageProperty}
        />
      </Message>
    </div>
  );
};

export default ClanDescriptionPreModeraion;
